import clsx from 'clsx'
import {Link, useNavigate} from 'react-router-dom'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {useLayout} from '../../core'
import {DefaultTitle} from './page-title/DefaultTitle'
import {Topbar} from './Topbar'
import {MenuItem} from './MenuItem'
import {useAuth} from 'app/modules/auth/auth'
import {useUser} from 'app/modules/auth/hooks'
import {getLocalStorage} from 'app/utils'

export function HeaderWrapper() {
  const {config, classes, attributes} = useLayout()
  const {logout, isLoggedIn} = useAuth()
  const navigate = useNavigate()
  const {header, aside} = config
  const {data} = useUser(getLocalStorage('access_token'))
  let loggedIn =
    isLoggedIn && data?.data.data !== 'خطای احراز هویت' && getLocalStorage('access_token')

  const handleLogin = () => {
    const API_URL = process.env.REACT_APP_API_URL
    if (loggedIn) navigate('/profile')
    else window.open(API_URL + '/login', '_self')
  }

  return (
    <div
      id='kt_header'
      className={clsx('header', classes.header.join(' '), 'align-items-stretch')}
      {...attributes.headerMenu}
    >
      <div
        className={clsx(
          classes.headerContainer.join(' '),
          'd-flex align-items-stretch justify-content-between'
        )}
      >
        {/* begin::Aside mobile toggle */}
        {aside.display && (
          <div className='d-flex align-items-center d-lg-none ms-n3 me-1' title='Show aside menu'>
            <div
              className='btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px'
              id='kt_aside_mobile_toggle'
            >
              <KTSVG path='/media/icons/duotune/abstract/abs015.svg' className='svg-icon-2x mt-1' />
            </div>
          </div>
        )}
        {/* end::Aside mobile toggle */}
        {/* begin::Logo */}
        {!aside.display && (
          <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0'>
            <Link to='/dashboard' className='d-lg-none'>
              <img
                alt='Logo'
                src={toAbsoluteUrl('/media/logos/logo_dark.png')}
                className='h-30px'
              />
            </Link>
          </div>
        )}
        {/* end::Logo */}

        {aside.display && (
          <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0'>
            <Link to='/' className='d-lg-none' target='_blank' rel='noopener noreferrer'>
              <img
                alt='Logo'
                src={toAbsoluteUrl('/media/logos/logo_dark.png')}
                className='h-30px'
              />
            </Link>
          </div>
        )}

        {/* begin::Wrapper */}
        <div className='d-flex align-items-stretch justify-content-between flex-lg-grow-1'>
          {/* begin::Navbar */}
          {header.left === 'menu' && (
            <div className='d-flex align-items-stretch' id='kt_header_nav'>
              {/* <Header /> */}
              <div className='header-menu align-items-stretch'>
                <div className='menu menu-lg-rounded menu-column menu-lg-row menu-state-bg menu-title-gray-700 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-400 fw-bold my-5 my-lg-0 align-items-stretch'>
                  <Link to='https://birjand.ac.ir/fa'>
                    <img
                      alt='Logo'
                      src={toAbsoluteUrl('/media/logos/logo_dark.png')}
                      className='h-60px'
                    />
                  </Link>
                  <MenuItem title='پنجره واحد خدمات دانشگاه' to='/dashboard' />
                  {!loggedIn ? (
                    <div className='menu-item me-lg-1'>
                      <div className='menu-link py-3' onClick={() => handleLogin()}>
                        <b className='menu-title text-success fs-4 fw-bolder'>
                          ورود از طریق پنجره ملی خدمات دولت هوشمند
                        </b>
                      </div>
                    </div>
                  ) : (
                    <div className='menu-item me-lg-1'>
                      <div className='menu-link py-3' onClick={() => handleLogin()}>
                        <span className='menu-title'>پروفایل</span>
                      </div>
                    </div>
                  )}
                  {loggedIn && (
                    <div className='menu-item me-lg-1'>
                      <div
                        className='menu-link py-3'
                        onClick={() => {
                          navigate('/dashboard')
                          logout()
                        }}
                      >
                        <span className='menu-title'>خروج</span>
                      </div>
                    </div>
                  )}
                  <div className='menu-item me-lg-1'>
                    <div
                      className='menu-link py-3'
                      onClick={() => window.open('https://birjand.ac.ir', '_self')}
                    >
                      <span className='menu-title text-primary fs-5'>صفحه اصلی دانشگاه </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {header.left === 'page-title' && (
            <div className='d-flex align-items-center' id='kt_header_nav'>
              <DefaultTitle />
            </div>
          )}
          <div className='d-flex align-items-stretch flex-shrink-0'>
            <Topbar />
          </div>
        </div>
        {/* end::Wrapper */}
      </div>
    </div>
  )
}
